import React from "react";
import { DataCardShell } from "../../responsive";
import Helpers from "../../Helpers";
import MasterRowActions from "../MasterRowActions";

export function BilingualMasterCard({
  row,
  englishField,
  spanishField,
  createdField = "createdAt",
  isAdmin,
  onEdit,
  onDelete,
}: {
  row: any;
  englishField: string;
  spanishField: string;
  createdField?: string;
  isAdmin: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
}) {
  return (
    <DataCardShell
      title={row[englishField] || "—"}
      subtitle={row[spanishField] || undefined}
      fields={[
        {
          label: "Created",
          value: row[createdField]
            ? Helpers.convertUtcToTimezone(row[createdField], "MM-DD-YYYY")
            : "—",
        },
      ]}
      primaryAction={
        isAdmin ? (
          <MasterRowActions
            onEdit={() => onEdit(row)}
            onDelete={() => onDelete(row)}
          />
        ) : undefined
      }
    />
  );
}
